import { ScaleChartData } from "../scale-chart"

export interface PolicyDetail {
    Product: string
    SocietyCode: number
    SocietyName: string
    Duration: string
    TMDescription: string
    SuggestedPeriod: string
    MinSinglePremium: number
    MinNextInvest: number
    RecurPremium?: any
    RefundMin: number
    PartialRefundMin: number
    PartialRefundMax: number
    RefundCap: number
    MaxAge: number
    IsInjury: boolean
    IsConvertible: boolean
    IsPartialRefund: boolean
    IsDeferral: boolean
    IsCoupon: boolean
    FidaCode: string
    Name: string
    Isin: string
    Rating?: number
    RatingDate?: Date
    RiskGradeMin?: number
    RiskGradeMax?: number
    Class: string
    ClassCode: number
    ScoreCosts: number
    ScoreOptions: number
    ScoreInstruments: number
    StatusCode: number
    CategoryName: string
    UnderlyingNum: number
    IsMultiOption: boolean
    CapConservGuarantee: string
    Guarantee: string
    IsTMGrowth: boolean
    IsTMIncome: boolean
    IsTMPreserve: boolean
    AnnualCost: string
    ModerateScenario : string
    FavorableScenario : string
    UnfavourableScenario : string
    StressScenario : string
    
    RiskGrade: string  //Non viene restituito direttamente dalla api
    InvestTrgt: string //Non viene restituito direttamente dalla api
    isFavorite: boolean // Non viene restituito direttamente dalla api
}


export interface SubstringReplcer { topstring: string, placeholder: string };

export enum SectionsKeys {
  TARGETMARKET = 'targetMarket',
  CARATTERISTICHE = 'caratteristiche',
  VERSAMENTIRISCATTI = 'versamentiRiscatti',
  PRESTAZIONIFINANZIARIE = 'prestazioniFinanziarie',



  CONTENUTIASSICURATIVI = 'contenutiAssicurativi',
  PRESTAZIONIACCESSORIE = 'prestazioniAccessorie',
  OPZIONI = 'opzioni',
}

export type MapType = 'string' | 'number' | 'float' | 'bool' | 'si-no' | 'scale' | 'num-img' | 'dettaglio';
export type MapAlign = 'start' | 'end' | 'center' | 'justify';

export interface Mapping {
  key: string;
  label: string;
  type: MapType
  align?: MapAlign;
  /** if true && value < 0 --> nessuno in table */
  nessuno?: true;
  substring?: { singular: SubstringReplcer, plural?: SubstringReplcer };
  isWithLabel?: boolean;
  description?: string;
}

export interface Mapped {
  key: string;
  label: string;
  value: string | ScaleChartData;
  align: MapAlign;
  isWithLabel: boolean;
  type: MapType;
  description?: string;
}

export interface MappedSection {
    key: string;
    label: string;
    mapped: Mapped[];
}